import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { usePageView } from 'src/hooks/use-page-view';

import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { useTreeViewApiRef } from '@mui/x-tree-view/hooks';

export const ListTree = (props) => {
  const {
    items = [],
    defaultItem = [],
    onItemClicked,
    onItemExpansion,
    // onEditedItem,
  } = props;
  const apiRef = useTreeViewApiRef();

  usePageView();

  // const getLabelById = (items, itemId) => {
  //   for (let item of items) {
  //     if (item.id === itemId) {
  //       return item.label; // Return label if found
  //     }
  //     // If not found, recursively search through children
  //     if (item.children && item.children.length > 0) {
  //       const label = getLabelById(item.children, itemId);
  //       if (label) return label; // If found in children, return label
  //     }
  //   }
  //   return null; // Return null if the item is not found
  // };

  const handleSelectedItemsChange = (event, itemId) => {
    if (itemId) {
      const { label } = apiRef.current.getItem(itemId);
      // const label = getLabelById(items, itemId);
      const children = apiRef.current.getItemOrderedChildrenIds(itemId);
      onItemClicked(itemId, label, children.length === 0); // Pass id and label to the handler
    }
  };

  return (
    <Box sx={{ p: 1 }}>
      <RichTreeView
        defaultExpandedItems={defaultItem}
        items={items}
        apiRef={apiRef}
        onSelectedItemsChange={handleSelectedItemsChange}
        onItemExpansionToggle={(event, itemId, isExpanded) =>
          onItemExpansion(itemId, isExpanded)
        }
        // Change item
        /**
         * isItemEditable
         * experimentalFeatures={{ labelEditing: true }}
         * onItemLabelChange={(itemId, label) => onEditedItem(itemId, label)}
         */
      />
    </Box>
  );
};

ListTree.propTypes = {
  items: PropTypes.array,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array,
};
